<template>
    <v-card class="mock-card">
        <v-row style="background: gray;">
            <img v-if="imageSrc" :src="imageSrc" @click="imageClick" class="mock-card-image clickable" />
            <img v-else :src="imagePlaceHolder" @click="imageClick" class="mock-card-image clickable" />
        </v-row>
        <v-row class="mock-card-display">
            <site-button
                colorClasses="secondary-color"
                toolTip="Nah I'm Good" 
                iconString="fas fa-times-circle"></site-button>
            <v-flex class="mock-card-text-display">
                <div>
                    <span>{{ title }}</span>
                </div>
                <div>
                    <span>{{ restriction }}</span>
                </div>
            </v-flex>
            <site-button
                colorClasses="primary-color"
                @click-event="interestedClick"
                toolTip="I'm Interested"
                iconString="fas fa-running"></site-button>
        </v-row>
        <v-row class="center">
            <site-button
                v-if="!isActive"
                @click-event="setActive(currentIndex)"
                :colNum="8"
                :marginNumber="2"
                :iconString="activationIcon"
                iconType="SVG"
                btnType="text"
                text="Activate Ad"
                colorClasses="secondary-icon mb-5"
                iconColor="primary-icon"
            ></site-button>
            <site-button
                v-else
                @click-event="setTargetMarket(currentIndex)"
                :colNum="8"
                :marginNumber="2"
                :iconString="targetMarket"
                iconType="SVG"
                btnType="text"
                text="Set Target Market"
                colorClasses="secondary-icon mb-5"
                iconColor="primary-icon"
            ></site-button>
        </v-row>
    </v-card>
</template>

<style scoped>
.clickable{
    cursor: pointer;
}
</style>

<script>
import HoverButton from "./SiteButton";

export default {
    components: {
        "site-button": HoverButton
    },
    props: {
        title: {
            type: String,
            default: 'Default Title',
        },
        restriction: {
            type: Object,
            default: () => {
                return null;
            },
        },
        updateIndex: {
            type: Number,
            default: -1
        },
        imageClick: {
            type: Function,
            default: undefined
        },
        interestedClick: {
            type: Function,
            default: undefined
        },
        imageSrc: {
            type: String,
            default: ''
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        setActive(){
            this.$emit('activate', this.updateIndex);
        },
        setTargetMarket(){
            this.$emit('target-market', this.updateIndex);
        }
    },
    computed: {
        imagePlaceHolder() {
            return require('../../assets/Add-Image-Placeholder.svg');
        },
        hasImageClick(){
            return this.imageClick !== undefined;
        },
        activationIcon() {
            return require('../../assets/Activate-Icon.svg');
        },
        targetMarket(){
            return require('../../assets/Target-Market.svg');
        }
    },
}
</script>
